"use client";

// src/components/modal/modal.tsx
import {
  useCallback,
  useEffect,
  useId,
  useRef,
  useState
} from "react";
import { tv } from "tailwind-variants";
import { Popover } from "../popover/popover.mjs";
import { jsx } from "react/jsx-runtime";
var modalStyles = tv({
  slots: {
    container: "fixed inset-0 flex z-20 overflow-hidden",
    dialog: "backdrop:bg-black/50 backdrop:backdrop-blur-sm z-40",
    popover: "self-center mx-auto z-40"
  }
});
var Modal = ({
  className,
  open: isOpenFromProps = true,
  onClose = () => null,
  children,
  label,
  ...popoverProps
}) => {
  const styles = modalStyles();
  const uid = useId();
  const dialogRef = useRef(null);
  const [isOpen, setIsOpen] = useState(isOpenFromProps);
  useEffect(() => {
    setIsOpen(isOpenFromProps);
  }, [isOpenFromProps]);
  const handleClose = useCallback(() => {
    setIsOpen(false);
    onClose(false);
  }, [onClose]);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (isOpen) {
      dialog.showModal();
      document.body.style.overflow = "hidden";
    } else {
      dialog.close();
      document.body.style.overflow = "";
    }
    return () => {
      if (dialog?.open) {
        dialog.close();
      }
      document.body.style.overflow = "";
    };
  }, [isOpen]);
  const handleNativeClose = (e) => {
    e.preventDefault();
    handleClose();
  };
  return isOpen && /* @__PURE__ */ jsx("div", { className: styles.container({ className: className?.container }), children: /* @__PURE__ */ jsx(
    "dialog",
    {
      ref: dialogRef,
      className: styles.dialog({ className: className?.dialog }),
      "aria-label": label,
      onCancel: handleNativeClose,
      children: /* @__PURE__ */ jsx(
        Popover,
        {
          ...popoverProps,
          tabIndex: 0,
          id: uid,
          open: isOpen,
          className: styles.popover({ className: className?.popover }),
          onClickOutside: handleClose,
          children
        }
      )
    }
  ) });
};
export {
  Modal
};
